import { FormControl, FormLabel, GridItem, Stack, Text } from '@chakra-ui/react';
import gql from 'graphql-tag';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ConfigurationStatusType } from '~components/configurations/ConfigStateToggle';
import { FormLabelPendingIndicator } from '~components/ui/FormLabelPendingIndicator';
import { ConfigBurnInRefreshSection_ConfigFragment } from './__generated__/ConfigBurnInRefreshSection.graphql';
import { ConfigBurnInRefreshTime } from './ConfigBurnInRefreshTime';

interface Props {
  config: ConfigBurnInRefreshSection_ConfigFragment;
  configStatus?: ConfigurationStatusType;
}

export function ConfigBurnInRefreshSection({ config, configStatus }: Props) {
  const { t } = useTranslation();
  const [isPending, setIsPending] = useState(false);

  return (
    <GridItem colSpan={{ base: 8, md: 7 }}>
      <Stack direction="column" spacing="10">
        <FormControl>
          <FormLabel>
            {t('refreshSchedule')}
            <FormLabelPendingIndicator isPending={isPending} />
          </FormLabel>
          <Text color="gray.500" mb="4">
            {t('burnInRefreshText')}
          </Text>
          <ConfigBurnInRefreshTime
            config={config}
            configStatus={configStatus}
            onPendingChange={setIsPending}
          />
        </FormControl>
      </Stack>
    </GridItem>
  );
}

ConfigBurnInRefreshSection.graphql = {
  fragments: {
    ConfigBurnInRefreshSection_config: gql`
      fragment ConfigBurnInRefreshSection_config on ConfigurationModel {
        id
        ...ConfigBurnInRefreshTime_config
      }
    `,
  },
};
